import React from "react";
import { Link } from "react-router-dom";

import { LINKS } from "./linkList";

const generateLinks = () => {
  return LINKS.map((link, index) => {
    if (link.external) {
      return (
        <a
          className="linkButton"
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          role="button"
          key={index}
        >
          {link.text}
        </a>
      );
    } else {
      return (
        <Link to={link.url} key={index} className="linkButton">
          {link.text}
        </Link>
      );
    }
  });
};

const LinkInBio = () => {
  return (
    <div className="centerStyling fadeInFast">
      <div className="header">
        <p className="igHandle">@_abbymakes</p>
        {generateLinks()}
      </div>
    </div>
  );
};

export default LinkInBio;
